import { Link } from "react-router-dom";
import { Megaphone, ArrowRight } from "lucide-react";

export default function PressRelease() {
  const published = "June 2026";
  return (
    <div className="max-w-[900px] mx-auto px-4 sm:px-6 py-16 sm:py-24" data-testid="press-release-page">
      <div className="flex items-center gap-3 mb-6">
        <span className="h-11 w-11 flex items-center justify-center bg-[#FF3B30]">
          <Megaphone size={22} className="text-white" />
        </span>
        <span className="text-xs font-bold uppercase tracking-[0.3em] text-[#FF3B30]">For Immediate Release</span>
      </div>

      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.95] uppercase mb-4" data-testid="press-headline">
        Official Rebranding Notice:<br />
        <span className="text-[#FF3B30]">Monster Truck Lord</span> is now <span className="text-[#FF3B30]">MonsterTruckLord</span>
      </h1>

      <p className="text-xs font-bold uppercase tracking-[0.25em] text-zinc-500 mb-10">Published {published} · Official Statement</p>

      <div className="border border-zinc-800 bg-zinc-950 p-6 sm:p-10 space-y-6 text-zinc-300 text-base leading-relaxed">
        <p data-testid="press-statement">
          This is an official statement confirming that the brand and Facebook Page formerly known as
          <span className="text-white font-bold"> “Monster Truck Lord” </span>
          has been rebranded to
          <span className="text-white font-bold"> “MonsterTruckLord” </span>
          (written as a single word, with the spaces between the three words removed).
        </p>

        <div className="border-l-2 border-[#FF3B30] pl-5 py-1 bg-zinc-900/40">
          <p className="text-sm uppercase tracking-widest text-zinc-500 mb-2 font-bold">Name Change Summary</p>
          <p className="text-sm">
            <span className="text-zinc-400">Previous name:</span> <span className="text-white font-bold">Monster Truck Lord</span>
          </p>
          <p className="text-sm">
            <span className="text-zinc-400">New name:</span> <span className="text-white font-bold">MonsterTruckLord</span>
          </p>
        </div>

        <p>
          The updated name, <span className="text-white font-bold">MonsterTruckLord</span>, removes the spaces between the
          three words in order to comply with platform naming requirements and to unify our identity across all
          channels — including our YouTube channel, Facebook Page, and official merchandise store at
          <span className="text-white font-bold"> monstertrucklord.com</span>.
        </p>

        <p>
          There has been <span className="text-white font-bold">no change in ownership, management, or the content and
          community</span> behind the brand. This is strictly a name-format update; the same team continues to operate
          the page and produce the same content for our audience.
        </p>

        <p>
          This page serves as the official public record of the rebrand and may be referenced for verification purposes
          by social media platforms, partners, and press. The brand, its logo, and its associated accounts remain the
          exclusive property of MonsterTruckLord.
        </p>

        <div className="pt-4 border-t border-zinc-800">
          <p className="text-sm uppercase tracking-widest text-zinc-500 mb-1 font-bold">Media &amp; Verification Contact</p>
          <p className="text-sm text-zinc-400">Official Store: <span className="text-white">monstertrucklord.com</span></p>
          <p className="text-sm text-zinc-400">Brand: <span className="text-white">MonsterTruckLord</span></p>
        </div>
      </div>

      <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Link to="/shop" data-testid="press-shop-cta"
          className="inline-flex items-center gap-2 bg-[#FF3B30] text-white px-8 py-4 text-sm font-bold uppercase tracking-widest hover:bg-white hover:text-black transition-colors">
          Visit the Store <ArrowRight size={16} />
        </Link>
        <p className="text-xs text-zinc-600 uppercase tracking-widest">© {new Date().getFullYear()} MonsterTruckLord — All Rights Reserved</p>
      </div>
    </div>
  );
}
